<template>
    <div class="uk-width-large uk-container uk-container-center">
        <p class="uk-text-danger uk-text-center" v-if="completeMessage">{{completeMessage}}</p>
        <form class="padding-medium uk-border-rounded border-muted uk-background-default uk-box-shadow-small uk-margin-medium-bottom uk-margin-top" @submit.prevent="updateProfile" v-show="tab === 1">
            <div v-if="profileErrors" class="uk-form-danger">
                <ul v-if="profileErrors.name">
                    <li v-for="msg in profileErrors.name" :key="msg">{{ msg }}</li>
                </ul>
                <ul v-if="profileErrors.email">
                    <li v-for="msg in profileErrors.email" :key="msg">{{ msg }}</li>
                </ul>
                <ul v-if="profileErrors.meeting_url">
                    <li v-for="msg in profileErrors.meeting_url" :key="msg">{{ msg }}</li>
                </ul>
                <ul v-if="profileErrors.password">
                    <li v-for="msg in profileErrors.password" :key="msg">{{ msg }}</li>
                </ul>
            </div>

            <div class="uk-margin">
                <label for="username" class="uk-form-label">Name</label>
                <div class="uk-position-relative">
                    <span class="uk-form-icon" uk-icon="icon: user"></span>
                    <input type="text" class="uk-input" id="username" v-model="profileForm.name">
                </div>
            </div>
            <div class="uk-margin">
                <label for="email" class="uk-form-label">Email</label>
                <div class="uk-position-relative">
                    <span class="uk-form-icon" uk-icon="icon: mail"></span>
                    <input type="text" class="uk-input" id="email" v-model="profileForm.email">
                </div>
            </div>
            <div class="uk-margin">
                <label for="email" class="uk-form-label">Meeting URL</label>
                <div class="uk-position-relative">
                    <span class="uk-form-icon" uk-icon="icon: desktop"></span>
                    <input type="text" class="uk-input" id="meeting_url" v-model="profileForm.meeting_url">
                </div>
            </div>
            <div class="uk-margin">
                <label for="password" class="uk-form-label">Password</label>
                <div class="uk-position-relative">
                    <span class="uk-form-icon" uk-icon="icon: lock"></span>
                    <input type="password" class="uk-input" id="password" v-model="profileForm.password">
                </div>
            </div>
            <div class="uk-margin">
                <label for="password-confirmation" class="uk-form-label">Password (confirm)</label>
                <div class="uk-position-relative">
                    <span class="uk-form-icon" uk-icon="icon: lock"></span>
                    <input type="password" class="uk-input" id="password-confirmation" v-model="profileForm.password_confirmation">
                </div>
            </div>
            <div class="">
                <button type="submit" class="uk-width-1-1 uk-button uk-button-primary">{{ button.profile }}</button>
            </div>
        </form>


        <div class="uk-flex uk-flex-right">
            <RouterLink to="/leave">退会する&nbsp;></RouterLink>
        </div>
    </div>
</template>

<script>
import { getCookieValue } from '../util'

export default {
    data () {
        return {
            tab: 1,
            profileForm: {
                name: '',
                email: '',
                meeting_url: '',
                password: '',
                password_confirmation: ''
            },
            button: {
                profile: '',
            },
            completeMessage: null
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.auth.user
        },
        profileErrors () {
            return this.$store.state.profile.profileErrorsMessages
        },
        token () {
            return this.$store.state.auth.token
        },
        profileStatus () {
            return this.$store.state.profile.profileStatus
        },
    },
    methods: {
        async updateProfile () {
            this.button.profile = '...'
            const request_data = this.profileForm

            request_data['api_token'] = getCookieValue('token')

            await this.$store.dispatch('profile/update', request_data)

            if (this.profileStatus) {
                await this.$store.dispatch('auth/currentUser')
                this.completeMessage = '更新が完了しました。'
                this.setButtonText()
                this.clearError()
                // this.reload()
            }

            this.setButtonText()
        },
        clearError () {
            this.$store.commit('profile/setProfileErrorsMessages', null)
        },
        setButtonText() {
            this.button.profile = 'SAVE'
        },
        setFormValue() {
            this.profileForm.name = this.userInfo.name
            this.profileForm.email = this.userInfo.email
            this.profileForm.meeting_url = this.userInfo.meeting_url
        },
        reload() {
            this.$router.go({path: this.$router.currentRoute.path, force: true});
        },
    },
    mounted() {
        this.setFormValue()
    },
    created () {
        this.clearError()
        this.setButtonText()
    }
}
</script>
